import { Injectable } from '@angular/core';
import { Headers, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable()
export class PolicyService {
    private headers: Headers;
    private readonly apiEndPoint: string = environment.apiEndPoint;

    constructor(private authHttp: AuthHttp) {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');
    }

    getPolicies(): Observable<any> {
        const apiUrl = this.apiEndPoint + '/api/HRBusinessParter/GetPolicies';
        return this.authHttp.get(apiUrl, { headers: this.headers }).map((res: Response) => {
            return res.json();
        });
    }

    viewPolicy(id: number): Observable<Blob> {
    const apiUrl =
        this.apiEndPoint +
        '/api/HRBusinessParter/ViewPolicy?id=' + id;

    const options = new RequestOptions({
        headers: this.headers,
        responseType: ResponseContentType.Blob
    });

    return this.authHttp.get(apiUrl, options)
        .map((res: Response) => res.blob());
}

}



// WEBPACK FOOTER //
// ./src/app/Services/policy.service.ts